export interface MilestoneDef {
  id: string;
  title: string;
  description: string;
  /** Check function: returns true if the milestone is achieved */
  check: (ctx: MilestoneContext) => boolean;
}

export interface MilestoneContext {
  /** Current streaks keyed by habit ID */
  streaks: Map<string, number>;
  /** Total completions across all habits (done + backfill only) */
  totalCompletions: number;
}

export const MILESTONES: MilestoneDef[] = [
  {
    id: "7-day-streak",
    title: "One week strong",
    description: "You kept a habit going for 7 days straight.",
    check: (ctx) => {
      for (const streak of ctx.streaks.values()) {
        if (streak >= 7) return true;
      }
      return false;
    },
  },
  {
    id: "30-day-streak",
    title: "Monthly momentum",
    description: "30 days in a row — this is becoming part of who you are.",
    check: (ctx) => {
      for (const streak of ctx.streaks.values()) {
        if (streak >= 30) return true;
      }
      return false;
    },
  },
  {
    id: "100-completions",
    title: "Century mark",
    description: "100 completions total. Small steps really do add up.",
    check: (ctx) => ctx.totalCompletions >= 100,
  },
  {
    id: "365-day-streak",
    title: "Full year",
    description: "365 days without breaking stride. Remarkable.",
    check: (ctx) => {
      for (const streak of ctx.streaks.values()) {
        if (streak >= 365) return true;
      }
      return false;
    },
  },
];
